import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';


interface CustomSelectProps {
  options?: any[];
  value: any;
  onChange: (event: SelectChangeEvent<string | number>) => void;
  placeholder?: string;
  width?: string;
  height?: string;
  fontSize?: string;
  placeholderColor?: string;
  optionColor?: string;
  borderColor?: string;
  customStyles?: React.CSSProperties;
  renderValue?: (selected: any) => React.ReactNode;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select here',
  width = '190px',
  height = '35px',
  fontSize = '14px',
  placeholderColor = '#AFAFAF',
  optionColor = '#202020',
  borderColor = '#ebebeb',
  customStyles = {},
  renderValue = (selected) => selected,
}) => {
  return (
    <FormControl sx={{ width }}>
      <Select
        value={value}
        size="small"
        displayEmpty
        renderValue={(selected) => {
          if (selected === '' || selected === null) {
            return (
              <span style={{ color: placeholderColor, fontSize }}>
                {placeholder}
              </span>
            );
          }
          return (
            <span style={{ color: optionColor, fontSize }}>
              {renderValue(selected)}
            </span>
          );
        }}
        sx={{
          width,
          height,
          fontSize,
          color: optionColor,
          border: `0.1px solid ${borderColor}`,
          '& fieldset': {
            border: `0.1px solid ${borderColor} !important`, 
          },
          '&:hover fieldset': {
            border: `0.1px solid ${borderColor} !important`, 
          },
          '&.Mui-focused fieldset': {
            border: `0.1px solid ${borderColor} !important`, 
          },
          ...customStyles,
        }}
        onChange={onChange}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              color: optionColor,
              fontSize,
            }}
          >
            <span>{option.label}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
